import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import swal from "sweetalert";
import { Loading } from "seed/helpers";
import { usePagination, useDelete } from "seed/gql";
import { DELETE_FLOW_NOTE } from "seed/gql/queries";
import l from "components/util/l";
import View from "components/presentation/history/notes/Notes.view"

const FlowNotes = forwardRef(({
  flow,
  selectedNote,
  isAdmin,
  onClickSelectNote = () => { },
}, ref) => {

  const userId = sessionStorage.getItem("id");
  const pageSize = 15;
  const [pageNum, setPageNum] = useState(1);
  const [createModal, setCreateModal] = useState(null);
  const [editModal, setEditModal] = useState(null);

  let queryFilter = `flow.id=${flow.id}`;
  if (!isAdmin) queryFilter = `(${queryFilter} AND user.id=${userId})`;

  const reqNotes = usePagination(`{
    flowNotePagination {
      totalPages
      flowNotes {
        createdAt
        title
        description
        user {
          firstName
          lastName
        }
        message {
          action
          content
          settings
        }
      }
    }
  }`,
    pageNum,
    pageSize,
    queryFilter,
    {
      orderBy: "-created_at"
    });

  const [callDelete] = useDelete(DELETE_FLOW_NOTE, {
    onCompleted: (data) => {
      reqNotes.refetch();
    }
  });

  const onClickDelete = (id) => {
    swal({
      title: l("Eliminar nota%PA039"),
      icon: "warning",
      text: l("¿Estás seguro que desea eliminar esta nota?%PA040"),
      buttons: {
        delete: {
          text: l("Eliminar%GA001"),
          className: "swal-button swal-button--cancel btn-danger px-2 w-100",
        },
        exit: {
          text: l("Cancelar%GA009"),
          className: "swal-button swal-button--cancel btn-secondary px-2 w-100",
        }
      },
    }).then((response) => {

      if (response == "delete")
        callDelete({ id: id });

    });
  }

  const refreshNotes = () =>
    reqNotes.refetch();

  useEffect(() => {
    reqNotes.refetch();
  }, []);

  useImperativeHandle(ref, () => ({
    refreshNotes
  }));

  if (reqNotes.loading) return <Loading />
  if (reqNotes.error) return ""

  const { totalPages = 0, flowNotes = [] } = reqNotes.data.flowNotePagination;

  return (
    <View
      flow={flow}
      selectedNote={selectedNote}
      pageNum={pageNum}
      totalPages={totalPages}
      flowNotes={flowNotes}
      createModal={createModal}
      editModal={editModal}
      setPageNum={setPageNum}
      setCreateModal={setCreateModal}
      setEditModal={setEditModal}
      refreshNotes={refreshNotes}
      onClickSelectNote={onClickSelectNote}
      onClickDelete={onClickDelete}
    />
  );
});

FlowNotes.displayName = "FlowNotes";

export default FlowNotes;